"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var attending_1 = require("../../model/attending");
var dispatch_service_1 = require("../../service/dispatch.service");
var authentication_service_1 = require("../../../shared/service/authentication.service");
var auto_eletric_service_1 = require("../../../shared/service/auto-eletric.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var jira_ticket_service_1 = require("../../../appraisal/service/jira-ticket.service");
var datePickerOptions = require("../../../core/date-picker-options");
var moment = require("moment");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var DispatchComponent = /** @class */ (function () {
    function DispatchComponent(_dispatchService, _authService, _autoEletricService, _toastService, _jiraTicketService) {
        this._dispatchService = _dispatchService;
        this._authService = _authService;
        this._autoEletricService = _autoEletricService;
        this._toastService = _toastService;
        this._jiraTicketService = _jiraTicketService;
        this._attending = new attending_1.Attending();
        this.autoEletricAttributesTree = ['name'];
        this.autoEletricsResultLimit = 3;
        this.txOnSave = new core_1.EventEmitter();
        this.txOnCancel = new core_1.EventEmitter();
        this.datePickerFormat = datePickerOptions.minDatePicker;
        this.DISPATCH = 'DISPATCH';
        this.schedulingDateActions = new core_1.EventEmitter();
        this.estimatedDate = null;
        this.realDate = null;
        this.showAutoeletricsSuggestion = false;
        this.dispatchTicketInput = new Subject_1.Subject();
        this.findShippingCompanies();
        this.authenticatedUser = this._authService.getUserFromLocalStorage();
        this.setUpObservers();
    }
    DispatchComponent.prototype.ngOnInit = function () {
    };
    DispatchComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    Object.defineProperty(DispatchComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
            this._attending.dispatch.equipmentArrived = !!attending.dispatch.equipmentArrived;
            this.findArgosAutoEletrics();
            this.showStep();
            this.estimatedDate = moment(new Date(attending.dispatch.arrivalEstimatedDate)).format('DD/MM/YYYY');
            this.realDate = moment(new Date(attending.dispatch.arrivalRealDate)).format('DD/MM/YYYY');
        },
        enumerable: true,
        configurable: true
    });
    DispatchComponent.prototype.save = function () {
        if (this.autoEletricId != null) {
            var associateAutoEletric = { 'attendingInfoId': this.attending.attendingInfo.id, 'autoEletricId': this.autoEletricId,
                'autoEletricStep': 'DISPATCH', 'suggestedByArgos': true };
            this.attending.dispatch.associateAutoeletric = associateAutoEletric;
        }
        this.attending.dispatch.arrivalEstimatedDate = moment("" + this.estimatedDate, 'DD/MM/YYYY');
        this.txOnSave.emit(this.attending);
    };
    DispatchComponent.prototype.cancel = function () {
        this.txOnCancel.emit();
    };
    DispatchComponent.prototype.findAutoEletric = function (name) {
        if (this.canEdit()) {
            this._autoEletricService.findByName(name);
        }
    };
    DispatchComponent.prototype.setEquipmentShippingStatus = function () {
        this.attending.dispatch.equipmentArrived = !this.attending.dispatch.equipmentArrived;
    };
    DispatchComponent.prototype.findArgosAutoEletrics = function () {
        var _this = this;
        if (this.attending.screening.providedServices.length > 0 && this.canEdit()) {
            this._autoEletricService
                .findBests(this.getSearchParams())
                .subscribe(function (autoEletrics) { return _this.argosAutoEletrics = autoEletrics; }, function (error) { return _this.showMessage(error.text); });
        }
    };
    DispatchComponent.prototype.selectAutoEletric = function (autoEletric) {
        if (this.autoEletricId === autoEletric.id) {
            this.autoEletricId = null;
        }
        else {
            this.autoEletricId = autoEletric.id;
        }
    };
    DispatchComponent.prototype.canEdit = function () {
        return (this.attending.dispatch.canEdit || this.attending.dispatch.canEdit === undefined) && this.editable;
    };
    DispatchComponent.prototype.canView = function () {
        return this.attending.dispatch.canView && !this.canEdit();
    };
    DispatchComponent.prototype.canSetEquipmentArrived = function () {
        return this.attending.dispatch.id != null;
    };
    DispatchComponent.prototype.getObjectKeys = function (object) {
        if (object) {
            return Object.keys(object);
        }
        return [];
    };
    DispatchComponent.prototype.toggleDatePicker = function () {
        this.schedulingDateActions.emit({ action: 'pickadate', params: ['open'] });
    };
    DispatchComponent.prototype.showAutoeletrics = function () {
        this.showAutoeletricsSuggestion = true;
    };
    DispatchComponent.prototype.setUpObservers = function () {
        var _this = this;
        this.setUpDispatchTicketInputObserver();
        this._autoEletricService.find$
            .filter(function (result) { return result instanceof Array; })
            .subscribe(function (autoEletrics) { return _this.userAutoEletrics = autoEletrics; });
    };
    DispatchComponent.prototype.getSearchParams = function () {
        return {
            providedServices: this.attending.screening.providedServices,
            branchId: this.attending.branch ? this.attending.branch.id : null,
            equipmentModelId: this.attending.screening.equipmentModel ? this.attending.screening.equipmentModel.id : null,
            resultLimit: this.autoEletricsResultLimit,
            accessoryMovementLogs: this.attending.accessoryMovementLogs
        };
    };
    DispatchComponent.prototype.showStep = function () {
        if (this.attending.orderedSteps && this.attending.currentStep === this.DISPATCH) {
            this.setIsVisible();
            this.setIsEditable();
        }
    };
    DispatchComponent.prototype.setIsVisible = function () {
        var _this = this;
        if (this.attending.orderedSteps.includes(this.DISPATCH)
            && this.authenticatedUser.stepViews.find(function (view) { return view.stepViewType === _this.DISPATCH; })) {
            this.attending.dispatch.canView = true;
        }
        else {
            this.attending.dispatch.canView = false;
        }
    };
    DispatchComponent.prototype.setIsEditable = function () {
        var _this = this;
        if (this.authenticatedUser.stepKeys.find(function (view) { return view.stepType === _this.DISPATCH; })) {
            this.attending.dispatch.canEdit = true;
        }
        else {
            this.attending.dispatch.canEdit = false;
        }
    };
    DispatchComponent.prototype.findShippingCompanies = function () {
        var _this = this;
        this._dispatchService.findShippingCompanies()
            .subscribe(function (companies) { return _this.shippingCompanies = companies; }, function (error) { return _this.showMessage(error.text); });
    };
    DispatchComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    DispatchComponent.prototype.setUpDispatchTicketInputObserver = function () {
        var _this = this;
        this.dispatchTicketInput
            .map(function (event) { return event.target.value; })
            .debounceTime(750)
            .distinctUntilChanged()
            .flatMap(function (search) { return Observable_1.Observable.of(search).delay(750); })
            .subscribe(function (typedValue) {
            if (typedValue && typedValue !== '' && _this.canEdit()) {
                _this.findDispatchTicket(typedValue);
            }
        });
    };
    DispatchComponent.prototype.findDispatchTicket = function (dispatchTicketCod) {
        var _this = this;
        this._jiraTicketService.find$
            .subscribe(function (dispatchTicket) { return _this.resolveDispatchTicket(dispatchTicketCod, dispatchTicket); });
        this.resolveDispatchTicket(dispatchTicketCod, this._jiraTicketService.findJiraTicket(dispatchTicketCod));
    };
    DispatchComponent.prototype.resolveDispatchTicket = function (dispatchTicketCod, dispatchTicket) {
        if (dispatchTicket) {
            if (dispatchTicket.invoiceNumber) {
                this.attending.invoiceNumber = dispatchTicket.invoiceNumber;
                this.attending.dispatch.dispatchTicket = dispatchTicketCod;
            }
        }
    };
    DispatchComponent.ctorParameters = function () { return [{ type: dispatch_service_1.DispatchService }, { type: authentication_service_1.AuthenticationService }, { type: auto_eletric_service_1.AutoEletricService }, { type: toast_service_1.ToastService }, { type: jira_ticket_service_1.JiraTicketService }]; };
    return DispatchComponent;
}());
exports.DispatchComponent = DispatchComponent;
//# sourceMappingURL=dispatch.component.js.map


// WEBPACK FOOTER //
// dispatch.component.js